module.exports = __webpack_public_path__ + "static/react-tiny-grid-b5134690524f4069718e1bafaf10d2c6.jpg";